import { render, staticRenderFns } from "./institution-evol-table.vue?vue&type=template&id=7e980cad&scoped=true&lang=pug&"
import script from "./institution-evol-table.vue?vue&type=script&lang=ts&"
export * from "./institution-evol-table.vue?vue&type=script&lang=ts&"
import style0 from "./institution-evol-table.vue?vue&type=style&index=0&id=7e980cad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e980cad",
  null
  
)

export default component.exports